import { ApolloLink, fromError, Observable } from 'apollo-link';
import { checkFetcher, selectURI, selectHttpOptionsAndBody, fallbackHttpConfig, serializeFetchParameter, createSignalIfSupported, parseAndCheckHttpResponse } from 'apollo-link-http-common';
import { BatchLink } from 'apollo-link-batch';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}

var BatchHttpLink = function (_super) {
  __extends(BatchHttpLink, _super);

  function BatchHttpLink(fetchParams) {
    if (fetchParams === void 0) {
      fetchParams = {};
    }

    var _this = _super.call(this) || this;

    var _a = fetchParams.uri,
        uri = _a === void 0 ? '/graphql' : _a,
        fetcher = fetchParams.fetch,
        includeExtensions = fetchParams.includeExtensions,
        batchInterval = fetchParams.batchInterval,
        batchMax = fetchParams.batchMax,
        batchKey = fetchParams.batchKey,
        requestOptions = __rest(fetchParams, ["uri", "fetch", "includeExtensions", "batchInterval", "batchMax", "batchKey"]);

    checkFetcher(fetcher);

    if (!fetcher) {
      fetcher = fetch;
    }

    var linkConfig = {
      http: {
        includeExtensions: includeExtensions
      },
      options: requestOptions.fetchOptions,
      credentials: requestOptions.credentials,
      headers: requestOptions.headers
    };
    _this.batchInterval = batchInterval || 10;
    _this.batchMax = batchMax || 10;

    var batchHandler = function batchHandler(operations) {
      var chosenURI = selectURI(operations[0], uri);
      var context = operations[0].getContext();
      var contextConfig = {
        http: context.http,
        options: context.fetchOptions,
        credentials: context.credentials,
        headers: context.headers
      };
      var optsAndBody = operations.map(function (operation) {
        return selectHttpOptionsAndBody(operation, fallbackHttpConfig, linkConfig, contextConfig);
      });
      var loadedBody = optsAndBody.map(function (_a) {
        var body = _a.body;
        return body;
      });
      var options = optsAndBody[0].options;

      if (options.method === 'GET') {
        return fromError(new Error('apollo-link-batch-http does not support GET requests'));
      }

      try {
        options.body = serializeFetchParameter(loadedBody, 'Payload');
      } catch (parseError) {
        return fromError(parseError);
      }

      var controller;

      if (!options.signal) {
        var _a = createSignalIfSupported(),
            _controller = _a.controller,
            signal = _a.signal;

        controller = _controller;
        if (controller) options.signal = signal;
      }

      return new Observable(function (observer) {
        fetcher(chosenURI, options).then(function (response) {
          operations.forEach(function (operation) {
            return operation.setContext({
              response: response
            });
          });
          return response;
        }).then(parseAndCheckHttpResponse(operations)).then(function (result) {
          observer.next(result);
          observer.complete();
          return result;
        }).catch(function (err) {
          if (err.name === 'AbortError') return;

          if (err.result && err.result.errors && err.result.data) {
            observer.next(err.result);
          }

          observer.error(err);
        });
        return function () {
          if (controller) controller.abort();
        };
      });
    };

    batchKey = batchKey || function (operation) {
      var context = operation.getContext();
      var contextConfig = {
        http: context.http,
        options: context.fetchOptions,
        credentials: context.credentials,
        headers: context.headers
      };
      return selectURI(operation, uri) + JSON.stringify(contextConfig);
    };

    _this.batcher = new BatchLink({
      batchInterval: _this.batchInterval,
      batchMax: _this.batchMax,
      batchKey: batchKey,
      batchHandler: batchHandler
    });
    return _this;
  }

  BatchHttpLink.prototype.request = function (operation) {
    return this.batcher.request(operation);
  };

  return BatchHttpLink;
}(ApolloLink);

export { BatchHttpLink };